import { useCallback } from 'react';
import { resolveComposerActionIntent } from '../../application/actions/dispatch.js';

export function useComposerChooserHandlers({ onChange } = {}) {
  const onComposerActionSelect = useCallback((choice) => {
    const actionIntent = resolveComposerActionIntent(choice);
    if (actionIntent.kind === 'prefill') return onChange?.({ target: { value: actionIntent.content } });
  }, [onChange]);
  return { onComposerActionSelect };
}

export default useComposerChooserHandlers;
